import { Button, Col, Form, Row, Spinner } from "react-bootstrap";

function formatMonthValue(year, month) {
  return `${year}-${String(month).padStart(2, "0")}`;
}

function parseMonthValue(value) {
  const [year, month] = String(value).split("-").map(Number);

  return {
    year,
    month,
  };
}

export default function WorkTimeRangePicker({
  value,
  onChange,
  onSubmit,
  loading,
}) {
  const fromValue = formatMonthValue(value.yearFrom, value.monthFrom);
  const toValue = formatMonthValue(value.yearTo, value.monthTo);

  const handleFromChange = (e) => {
    const parsed = parseMonthValue(e.target.value);

    onChange({
      ...value,
      monthFrom: parsed.month,
      yearFrom: parsed.year,
    });
  };

  const handleToChange = (e) => {
    const parsed = parseMonthValue(e.target.value);

    onChange({
      ...value,
      monthTo: parsed.month,
      yearTo: parsed.year,
    });
  };

  return (
    <Form onSubmit={onSubmit} className="mb-4">
      <Row className="g-3 align-items-end">
        <Col xs={12} md={4}>
          <Form.Group>
            <Form.Label>Zakres od</Form.Label>
            <Form.Control
              type="month"
              value={fromValue}
              onChange={handleFromChange}
            />
          </Form.Group>
        </Col>

        <Col xs={12} md={4}>
          <Form.Group>
            <Form.Label>Zakres do</Form.Label>
            <Form.Control
              type="month"
              value={toValue}
              onChange={handleToChange}
            />
          </Form.Group>
        </Col>

        <Col xs={12} md="auto">
          <Button type="submit" disabled={loading}>
            {loading ? (
              <>
                <Spinner size="sm" className="me-2" />
                Pobieranie...
              </>
            ) : (
              "Pobierz"
            )}
          </Button>
        </Col>
      </Row>
    </Form>
  );
}